module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms13x"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms13xIndex,
      "searchBoxAlias": "hrms13x",
      "detailEvent": _vm.detailEvent,
      "csvExportDisp": true,
      "listFields": _vm.listFields,
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "indexSelected": _vm.indexSelected,
      "detail": _vm.detail,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "tab2Table": _vm.columns[_vm.app.nowLang].tab2,
      "tab3Table1": _vm.columns[_vm.app.nowLang].tab3table1,
      "tab3Table2": _vm.columns[_vm.app.nowLang].tab3table2,
      "tab4Table": _vm.columns[_vm.app.nowLang].tab4
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ef48e726!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms13x/component.vue
// module id = 4009
// module chunks = 1